import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";

const WHATSAPP_LINK = "https://api.whatsapp.com/send/?phone=553182934076&text=Ol%C3%A1%2C+gostaria+de+mais+informa%C3%A7%C3%B5es+sobre+gest%C3%A3o+de+tr%C3%A1fego+para+empresas+locais.&type=phone_number&app_absent=0";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
};

export const FinalCtaSection = () => {
  return (
    <section
      id="contato"
      data-testid="final-cta-section"
      className="relative py-24 lg:py-40 bg-[#050505] overflow-hidden"
    >
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#2563EB]/15 rounded-full blur-[150px]" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          {...fadeInUp}
          transition={{ duration: 0.6 }}
        >
          <span className="font-outfit uppercase tracking-[0.2em] text-xs font-semibold text-[#2563EB] mb-6 block">
            Próximo Passo
          </span>
          <h2 className="font-outfit font-bold text-4xl sm:text-5xl lg:text-6xl text-white mb-6 leading-tight">
            Se você quer crescer,{" "}
            <span className="text-gradient-blue">precisa de estratégia</span>
          </h2>
          <p className="text-[#A1A1AA] text-lg lg:text-xl max-w-2xl mx-auto mb-10">
            Agende uma reunião gratuita e descubra como podemos ajudar sua
            empresa a conquistar mais clientes de forma previsível.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-button"
              className="inline-flex items-center gap-3 bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-10 py-5 rounded-full text-lg font-semibold transition-colors duration-200 cta-glow btn-pulse"
            >
              <MessageCircle className="w-6 h-6" />
              Agendar Reunião Gratuita
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>

          <p className="text-[#A1A1AA] text-sm mt-8">
            Atendimento via WhatsApp • Resposta em até 24h
          </p>
        </motion.div>
      </div>
    </section>
  );
};
